import BaseError from './BaseError';

function XhrError(message, fileName, lineNumber) {
  const instance = new BaseError('XhrError', message, fileName, lineNumber);
  Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
  return instance;
}

XhrError.prototype = Object.create(BaseError.prototype, {
  constructor: {
    value: BaseError,
    enumerable: false,
    writable: true,
    configurable: true,
  },
});

Object.setPrototypeOf(XhrError, BaseError);

export default XhrError;
